import React, { useState, useMemo, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './menu.css';
import { useSelector, useDispatch } from 'react-redux';
import { getUserProfile } from 'reducer/user';
import {
  PieChartOutlined,
  UserOutlined,
  TeamOutlined,
  DollarOutlined,
  BarChartOutlined,
  SettingOutlined,
  SearchOutlined,
  ShopOutlined,
  GlobalOutlined,
  BankOutlined,
  CreditCardOutlined,
  EnvironmentOutlined,
  SafetyOutlined,
  ApiOutlined,
  ShoppingCartOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  LogoutOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';
import { Layout, Menu, Image, Breadcrumb, Avatar, Dropdown, Space, Typography, Button } from 'antd';
import HeaderContent from 'components/Header';
import Logo from 'assets/images/logo.png';
import ROUTES from 'config/routes.json';
import { useNavigate, useLocation } from 'react-router';
import Cookies from 'universal-cookie';
import ThemeToggle from 'components/ThemeToggle';
import { useTheme } from 'contexts/ThemeContext';
import ActivitiesIcon from 'assets/search/Activities';
import CarsIcon from 'assets/search/Cars';
import CruisesIcon from 'assets/search/Cruises';
import FlightIcon from 'assets/search/Flight';
import HoteltIcon from 'assets/search/Hotel';
import {ReportIcon} from 'assets/search/Resort';

const { Text } = Typography;
const cookies = new Cookies();

const { Header, Content, Sider } = Layout;

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

const items = [
  getItem('Dashboard', ROUTES.DASHBOARD, <PieChartOutlined />),
  getItem('Manage Admins', ROUTES.MANAGE_ADMINS, <UserOutlined />),
  //organization is a account
  getItem('Organization Report', ROUTES.ORGANIZATION_REPORT, <BankOutlined />),
  getItem('Manage Accounts', '/manage-agencies', <TeamOutlined />, [
    getItem('Accounts Reports', ROUTES.MANAGE_AGENCIES, <BarChartOutlined />),
    getItem('Accounts Monthly Commission', ROUTES.MANAGE_AGENCIES_COMMISSION, <DollarOutlined />),
    getItem('Accounts Credit Limit', ROUTES.MANAGE_AGENCIES_QUOTA, <UnorderedListOutlined />),
  ]),
  getItem('Manage Markups', '/manage-markups', <DollarOutlined />, [
    getItem('Platform Markups', ROUTES.MANAGE_PLATFORM_MARKUPS, <ShopOutlined />),
    // getItem('Service Markups', ROUTES.MANAGE_SERVICE_MARKUPS, <ShoppingCartOutlined />),
    getItem('Accounts Markups', ROUTES.MANAGE_AGENCY_MARKUPS, <TeamOutlined />),
    // getItem('Default Agency', ROUTES.MANAGE_DEFAULT_AGENCY_MARKUPS, <BankOutlined />),
  ]),
  getItem('Reports', '/reports', <BarChartOutlined />, [
    getItem('Hotel Reports', ROUTES.HOTEL_REPORTS, <HoteltIcon />),
    getItem('Car Reports', ROUTES.CAR_REPORTS, <CarsIcon />),
    getItem('Flight Reports', ROUTES.FLIGHT_REPORTS, <FlightIcon />),
    getItem('Activity Reports', ROUTES.ACTIVITY_REPORTS, <ActivitiesIcon />),
    //getItem('Cruise Reports', ROUTES.CRUISE_REPORTS, <CruisesIcon />),
    getItem('Resort Reports', ROUTES.RESORT_REPORTS, <ReportIcon />),
    // getItem('Total Reports', ROUTES.TOTAL_REPORTS),
  ]),
  getItem('Settings', '/settings', <SettingOutlined />, [
    // getItem('Hotel Radius', ROUTES.HOTEL_RADIUS, <EnvironmentOutlined />),
    // getItem('Hotel Vendor', ROUTES.HOTEL_VENDOR, <ShopOutlined />),
    getItem('Payment Gateway', ROUTES.PAYMENT_GATEWAY, <CreditCardOutlined />),
    getItem('Supplier Vendors', ROUTES.SUPPLIER_VENDORS, <ShopOutlined />),
    // getItem('Hotel AutoSuggest', ROUTES.HOTEL_AUTOSUGGEST, <SearchOutlined />),
    getItem('Supported Countries', ROUTES.COUNTRY, <GlobalOutlined />),
    // getItem('Cruise Lines', ROUTES.CRUISE_LINE, <RocketOutlined />),
    getItem('Locations', ROUTES.LOCATIONS, <EnvironmentOutlined />),
    getItem('OTP Signup Enable', ROUTES.OTP, <SafetyOutlined />),
    getItem('OTP-No Account Created', ROUTES.HIDE_HEADER, <SafetyOutlined />),
    getItem('Extranet', ROUTES.EXTRANET_SETTING, <ApiOutlined />),
    getItem('TripAdd', ROUTES.TRIP_ADD, <ShoppingCartOutlined />),
  ]),
  getItem('Searches', ROUTES.SEARCHES, <SearchOutlined />),
];

const LayoutWrapper = (props) => {
  const navigation = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [collapsed, setCollapsed] = useState(false);
  const userDetails = useSelector((state) => state.user.userDetails);
  const authToken = useSelector((state) => state.user.authToken);

  useEffect(() => {
    if (authToken && !userDetails) {
      dispatch(getUserProfile());
    }
  }, [authToken, userDetails, dispatch]);

  const handleChange = ({ key }) => {
    navigation(key);
  };

  const handleLogout = () => {
    ['loginInfo', 'loginTrue', 'isTrue'].forEach((item) => cookies.remove(item, { path: '/' }));
    localStorage.clear();
    cookies.remove('x-access-token', { path: '/' });
    document.location = '/';
  };

  const userMenuItems = [
    // {
    //   key: 'profile',
    //   icon: <UserOutlined />,
    //   label: 'Profile',
    // },
    // {
    //   key: 'settings',
    //   icon: <SettingOutlined />,
    //   label: 'Settings',
    // },
    // {
    //   type: 'divider',
    // },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      danger: true,
      onClick: handleLogout,
    },
  ];

  // Generate breadcrumbs
  const breadcrumbItems = useMemo(() => {
    const path = location.pathname;
    const findPath = (menuItems, currentPath = []) => {
      for (const item of menuItems) {
        if (item.key === path) {
          return [...currentPath, { title: item.label }];
        }
        if (item.children) {
          const found = findPath(item.children, [...currentPath, { title: item.label }]);
          if (found) return found;
        }
      }
      return null;
    };

    const pathItems = findPath(items);
    if (pathItems && pathItems.length > 0) {
      return [{ title: 'Home' }, ...pathItems];
    }
    return [{ title: 'Home' }];
  }, [location.pathname]);

  // Get current selected key from location
  const getSelectedKeys = () => {
    const path = location.pathname;
    // Find matching route - check children first, then parents
    const findRoute = (items) => {
      // First, check all children (submenu items)
      for (const item of items) {
        if (item.children) {
          for (const child of item.children) {
            // Exact match
            if (child.key === path) {
              return [child.key];
            }
            // Path starts with child key (for dynamic routes)
            if (
              path.startsWith(child.key + '/') ||
              (path.startsWith(child.key) && path.length > child.key.length && path[child.key.length] === '/')
            ) {
              return [child.key];
            }
          }
        }
      }
      // Then check parent items
      for (const item of items) {
        // Skip parents that have children (we already checked children)
        if (item.children && item.children.length > 0) {
          continue;
        }
        // Exact match for parent
        if (item.key === path) {
          return [item.key];
        }
        // Path starts with parent key
        if (
          path.startsWith(item.key + '/') ||
          (path.startsWith(item.key) && path.length > item.key.length && path[item.key.length] === '/')
        ) {
          return [item.key];
        }
      }
      return [];
    };
    return findRoute(items) || [];
  };

  const getOpenKeys = () => {
    const path = location.pathname;
    const openKeys = [];
    items.forEach((item) => {
      if (item.children) {
        // Check if any child matches the current path
        const hasMatch = item.children.some((child) => {
          return (
            child.key === path ||
            path.startsWith(child.key + '/') ||
            (path.startsWith(child.key) && path.length > child.key.length && path[child.key.length] === '/')
          );
        });
        if (hasMatch) openKeys.push(item.key);
      }
    });
    return openKeys;
  };

  const { isDark } = useTheme();
  const contentBg = isDark ? '#0a0a0a' : '#f5f7fa';
  const siderBg = isDark ? '#141414' : '#ffffff';
  const headerBg = isDark ? '#141414' : 'rgb(246, 247, 250)';
  const textColor = isDark ? '#ffffff' : '#000000';

  const siderWidth = 240;
  const collapsedWidth = 72;
  const headerHeight = 56;

  return (
    <Layout className="h-screen" style={{ background: contentBg, transition: 'background-color 0.3s ease' }}>
      <ToastContainer />
      {userDetails && (
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          width={siderWidth}
          collapsedWidth={collapsedWidth}
          className="layout-sider"
          style={{
            background: siderBg,
            height: '100vh',
            position: 'fixed',
            left: 0,
            top: 0,
            bottom: 0,
            borderRight: isDark ? '1px solid #2d2d2d' : '1px solid #eee',
            zIndex: 1000,
            transition: 'background-color 0.3s ease, border-color 0.3s ease',
            display: 'flex',
            flexDirection: 'column',
          }}
          theme={isDark ? 'dark' : 'light'}
        >
          {/* Logo */}
          <div
            style={{
              height: headerHeight,
              display: 'flex',
              alignItems: 'center',
              justifyContent: collapsed ? 'center' : 'flex-start',
              padding: collapsed ? '0' : '0 20px',
              borderBottom: isDark ? '1px solid #2d2d2d' : '1px solid #f0f0f0',
              flexShrink: 0,
            }}
          >
            <Image
              src={Logo}
              alt="logo"
              preview={false}
              width={collapsed ? 36 : 110}
              style={{
                transition: 'width 0.2s',
                ...(collapsed
                  ? {
                      borderRadius: 6,
                      padding: 2,
                      background: '#fff',
                      boxShadow: '0 1px 4px rgba(255,107,53,0.2)',
                      objectFit: 'contain',
                    }
                  : {}),
              }}
            />
          </div>

          {/* Menu — scrollable */}
          <div className="sider-menu-wrap" style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
            <Menu
              theme={isDark ? 'dark' : 'light'}
              selectedKeys={getSelectedKeys()}
              defaultOpenKeys={getOpenKeys()}
              mode="inline"
              items={items}
              onClick={handleChange}
              style={{
                borderRight: 'none',
                padding: '8px 0',
                background: siderBg,
                transition: 'background-color 0.3s ease',
              }}
              className="custom-menu"
            />
          </div>
        </Sider>
      )}

      <Layout
        style={{
          marginLeft: userDetails ? (collapsed ? collapsedWidth : siderWidth) : 0,
          transition: 'margin-left 0.2s',
          minHeight: '100vh',
        }}
      >
        {/* Navbar */}
        {userDetails && (
          <Header
            style={{
              background: headerBg,
              padding: '0 24px',
              position: 'sticky',
              top: 0,
              zIndex: 100,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              height: headerHeight,
              borderBottom: isDark ? '1px solid #2d2d2d' : '1px solid #eee',
              transition: 'background-color 0.3s ease, border-color 0.3s ease',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setCollapsed(!collapsed);
                }}
                style={{
                  fontSize: 16,
                  width: 36,
                  height: 36,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: 8,
                  color: textColor,
                }}
              />
              <Breadcrumb
                items={breadcrumbItems}
                separator="/"
                style={{ fontSize: 13 }}
              />
            </div>
            <Space size={12}>
              <ThemeToggle />
              <Dropdown menu={{ items: userMenuItems }} placement="bottomRight" trigger={['click']}>
                <div
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '4px 12px 4px 4px',
                    borderRadius: 8,
                    border: isDark ? '1px solid #333' : '1px solid #eee',
                    background: isDark ? '#1a1a1a' : '#fff',
                    transition: 'all 0.2s',
                  }}
                >
                  <Avatar
                    icon={<UserOutlined />}
                    size={28}
                    style={{ background: '#ff6b35' }}
                  />
                  <Text
                    strong
                    style={{
                      fontSize: 13,
                      color: textColor,
                      maxWidth: 120,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {userDetails?.name || userDetails?.email || 'User'}
                  </Text>
                </div>
              </Dropdown>
            </Space>
          </Header>
        )}

        {!userDetails && (
          <Header
            style={{
              background: '#fff',
              padding: '0 24px',
              boxShadow: '0 1px 4px rgba(0, 21, 41, 0.08)',
              height: headerHeight,
            }}
          >
            <HeaderContent />
          </Header>
        )}

        <Content
          style={{
            padding: userDetails ? '16px 24px 24px' : '24px',
            minHeight: `calc(100vh - ${headerHeight}px)`,
            background: contentBg,
            overflowY: 'auto',
            transition: 'background-color 0.3s ease',
          }}
        >
          {props.children}
        </Content>
      </Layout>
    </Layout>
  );
};
export default LayoutWrapper;
